<template>
    <div class="announce container-fluid">
        <div class="row">
            <div class="input-form col-md-4 offset-md-4 col-10 mx-auto" v-if="announce_1">
                <h3 class="announce-title col-md-12">ยืนยันสิทธิ์</h3>
                <div class="input-group col-md-12">
                    <label for="studentid" class="col-md-12">เลขประจำตัวนักเรียน</label>
                    <input type="text" class="studentid col-md-12" v-model="studentid">
                </div>
                <div class="input-group col-md-12">
                    <label for="phone" class="col-md-12">เบอร์โทรศัพท์</label>
                    <input type="text" class="phone col-md-12" v-model="phone" placeholder="ไม่มี - เช่น 0812345678">
                </div>
                <div class="col-md-4 offset-md-4 col-4 mx-auto text-center">
                    <button class="confirm-btn" @click="getName()" v-if="phone != '' && studentid != ''">ถัดไป</button>
                </div>
                <h6 class="check-text text-center" style="color:red;" v-if="check != ''">{{ check }}</h6>
            </div>
            <div class="input-form col-md-4 offset-md-4 col-10 mx-auto" v-if="announce_2">
                <h3 class="announce-title col-md-12">ยืนยันสิทธิ์</h3>
                <div class="col-md-12">
                    <p>น้อง{{ name }} ยืนยันที่จะเข้าร่วมค่าย DekCom Mini Camp VI ในวันที่ 25-26 สิงหาคมหรือไม่ (กดปุ่มเพื่อยืนยันเข้าร่วม)</p>
                </div>
                <div class="col-md-6 offset-md-3 col-8 mx-auto text-center">
                    <button class="confirm-btn" @click="announce_2 = !announce_2; announce_3 = !announce_3; confirmCamp()">ยืนยันเข้าร่วมค่าย</button>
                </div>
            </div>
            <div class="input-form col-md-4 offset-md-4 col-10 mx-auto" v-if="announce_3">
                <h3 class="announce-title col-md-12">แล้วเจอกันวันค่าย :)</h3>
                <div class="row">
                    <div class="col-md-6 text-center">
                        <h5>กลุ่มค่าย</h5>
                        <a href="https://www.facebook.com/groups/1452268445087233/">DekCom Mini Camp Group</a>
                    </div>
                    <div class="col-md-6 text-center">
                        <h5>เพจค่าย</h5>
                        <a href="https://www.facebook.com/DekComCamp/">DekCom Mini Camp Page</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from "firebase";
export default {
  name: "announce",
  data() {
    return {
      announce_1: true,
      announce_2: false,
      announce_3: false,

      phone: "",
      studentid: "",
      name: "",

      check: ""
    };
  },
  mounted() {},
  methods: {
    getName() {
      firebase
        .database()
        .ref("users/" + this.studentid)
        .once("value")
        .then(snapshot => {
          if (snapshot.val() == null) {
            // this.check = "ไม่มีเลขประจำตัวนี้ในระบบ กรุณาติดต่อที่เพจค่าย";
            this.check = "เนื่องจากปีนี้มีคนสมัครเข้ามาเป็นจำนวนมาก ทำให้พี่ไม่สามารถที่จะรับไว้ได้ทั้งหมด แต่ไม่ต้องเสียใจไปนะครับ กิจกรรมดี ๆ แบบนี้มีมาเรื่อย ๆ อย่าลืมกดไลก์ กดติดตามแฟนเพจเด็กคอมนะครับ";
          } else if (snapshot.val().phone != this.phone) {
            this.check = "ไม่มีเบอร์โทรนี้ในระบบ กรุณาติดต่อที่เพจค่าย";
          } else if (snapshot.val().choose == "reserve") {
            this.check = "น้องติดรายชื่อสำรอง รอติดตามอัพเดตเพิ่มเติมที่เพจค่าย";
          } else if (snapshot.val().choose == null) {
            this.check = "เนื่องจากปีนี้มีคนสมัครเข้ามาเป็นจำนวนมาก ทำให้พี่ไม่สามารถที่จะรับไว้ได้ทั้งหมด แต่ไม่ต้องเสียใจไปนะครับ กิจกรรมดี ๆ แบบนี้มีมาเรื่อย ๆ อย่าลืมกดไลก์ กดติดตามแฟนเพจเด็กคอมนะครับ";
          } else if (
            snapshot.val().phone == this.phone &&
            snapshot.val().choose == "real"
          ) {
            this.name = snapshot.val().name;
            this.announce_1 = !this.announce_1;
            this.announce_2 = !this.announce_2;
          }
        });
    },
    confirmCamp() {
      firebase
        .database()
        .ref("users/" + this.studentid)
        .update({
          confirm: true
        });
    }
  }
};
</script>

<style lang="scss" scoped>
label {
  padding: 0;
}

.announce {
  background: url("/static/assets/img/register_bg.jpg") center no-repeat fixed;
  background-size: cover;
  min-height: 100vh;
}

.input-form {
  margin: 5vh auto;
  box-shadow: 0 0 5px #ddd;
  padding: 15px 5px;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 5px #fff;
  min-height: 30vh;
}

.input-group {
  margin: 10px auto;
  & > input {
    border: 2px solid;
    padding: 5px 10px;
  }
}

.announce-title {
  text-align: center;
  border-bottom: 2px dashed;
  padding-bottom: 10px;
}

.confirm-btn {
  background: #fff;
  border: 2px solid;
  padding: 5px 15px;
  margin-top: 5px;
  cursor: pointer;
  &:hover {
    background: #212529;
    color: #fff;
  }
}

.check-text {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Announce.vue